import {
    DevBoxAddOnUnion as GeneratedDevBoxAddOnUnionBeta,
    DevBox as GeneratedDevBoxBeta,
    DevBoxProvisioningState as GeneratedDevBoxProvisioningStateBeta,
    PoolAlignBody as GeneratedPoolAlignBodyBeta,
    UserActiveHoursConfiguration as GeneratedUserActiveHoursConfigurationBeta,
} from 'devcenter-internal-beta';
import {
    DevBoxProvisioningState as GeneratedDevBoxProvisioningStateStable,
    DevBoxSnapshot as GeneratedDevBoxSnapshotStable,
    DevBox as GeneratedDevBoxStable,
    RemoteConnection as GeneratedRemoteConnectionStable,
} from 'devcenter-internal-stable';
import { RequiredProperty } from '../../types/required-property';
import { UnionMap } from '../../types/union-map';

/**
 * Data Plane SDK shim models
 */

export type StableDevBoxContract = GeneratedDevBoxStable;
export type BetaDevBoxContract = GeneratedDevBoxBeta;

export type DevBoxContractFromDataplane = BetaDevBoxContract;

// Note: making a distinction here between request and response contracts, which are treated as the same by code gen.
//      - DevBoxContract: response contract, in which readonly props (e.g. name, uri) are always available
//      - PutDevBoxBodyContract: PUT request contract, in which readonly props aren't required
export type DevBoxContract = RequiredProperty<BetaDevBoxContract, 'projectName'>;

export type PutDevBoxBodyContract = StableDevBoxContract;

export type RemoteConnectionContract = GeneratedRemoteConnectionStable;

export type DevBoxSnapshotContract = GeneratedDevBoxSnapshotStable;

export type DevBoxProvisioningStateContract =
    | GeneratedDevBoxProvisioningStateStable
    | GeneratedDevBoxProvisioningStateBeta;

export const DevBoxProvisioningStateContract: UnionMap<DevBoxProvisioningStateContract> = {
    Canceled: 'Canceled',
    Creating: 'Creating',
    Failed: 'Failed',
    Succeeded: 'Succeeded',
    Deleting: 'Deleting',
    Updating: 'Updating',
    Starting: 'Starting',
    Stopping: 'Stopping',
    InGracePeriod: 'InGracePeriod',
    NotProvisioned: 'NotProvisioned',
    PendingApproval: 'PendingApproval',
    Provisioning: 'Provisioning',
    ProvisionedWithWarning: 'ProvisionedWithWarning',
};

export type DevBoxAddOnUnionContract = GeneratedDevBoxAddOnUnionBeta;

export type PoolAlignBody = GeneratedPoolAlignBodyBeta;

export type UserActiveHoursConfiguration = GeneratedUserActiveHoursConfigurationBeta;
